import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { ExtensionTypes, TimeZones } from 'generated/graphql-types';
import { ExtensionDetailView } from '../../extension-details/models/extension-detail-view.model';
import { ExtensionPrivileges } from '../../extension-details/models/extension-privileges';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-extension-view',
    styleUrls: ['./add-extension-view.component.scss'],
    templateUrl: './add-extension-view.component.html',
    standalone: false
})
export class AddExtensionViewComponent {
   @Output() formSubmitted = new EventEmitter<boolean>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: UntypedFormGroup;

   @Input() callState: CallState;

   @Input() extension: ExtensionDetailView;

   @Input() accountId: number | null;

   @Input() extensionsForAdd: any | null;

   @Input() externalNumbers: any | null;

   @Input() extensionGroupsForAdd: any | null;

   @Input() timeZoneId: TimeZones | null;

   extensionTypes: typeof ExtensionTypes = ExtensionTypes;

   @Input() set extensionPrivileges(privileges: ExtensionPrivileges) {
      this._extensionPrivileges = privileges;
   }

   get extensionPrivileges(): ExtensionPrivileges {
      return this._extensionPrivileges;
   }

   private _extensionPrivileges: ExtensionPrivileges;

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(continuous = false): void {
      if (this.form.valid) {
         this.formSubmitted.emit(continuous);
      } else {
         this.form.markAllAsTouched();
      }
   }
}
